import { TwoDimensionalBarcodeFormatType } from "../../Enums";

const TwoDimensionalFormStages = [
  {
    title: "Content",
    sections: [
      {
        name: "",
        fields: [
          {
            name: "Name",
            description: "",
            label: "Name",
            mandatory: true,
            type: "nvarchar",
          },
          {
            name: "BarcodeFormat",
            enum: TwoDimensionalBarcodeFormatType,
            label: "Barcode Format",
            mandatory: true,
            type: "picklist",
          },
        ],
      },
    ],
  },
  {
    title: "Position",
    sections: [
      {
        name: "",
        fields: [
          {
            name: "Left",
            label: "Left",
            mandatory: true,
            type: "int",
          },
          { name: "Top", label: "Top", mandatory: true, type: "int" },
        ],
      },
    ],
  },
  {
    title: "Style",
    sections: [
      {
        name: "Size",
        fields: [
          {
            name: "Width",
            label: "Width",
            mandatory: true,
            type: "int",
          },
          {
            name: "Height",
            label: "Height",
            mandatory: true,
            type: "int",
          },
        ],
      },
    ],
  },
];

export default TwoDimensionalFormStages;
